import Button from "../button/Button";
import {getLiveChannelData } from "../../api/HttpApis";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

export const channelListData = async (
  selectedDate,
  selectedCreator,
  selectedRating,
  selectedGenre,
  page,
  perpage,
  search = ""
) => {
  const response = await getLiveChannelData(
    {},
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    perpage,
    page,
    search
  );
  const data = Array.isArray(response?.data?.data) ? response.data.data : [];

  const formattedData = data.map((channel) => ({
    id:
      channel.id || channel.original_id || channel.video_id || channel.movie_id,
    metadata_id: channel.metadata_id || channel.meta_id || channel.meta_data_id,
    name: trimStr(channel.name),
    media: channel.portrait,
    status: channel.status,
    qc_status: channel.qc_status,
    rating: channel.rating,
    access: channel.access,
    buttonText: "Edit",
    buttonText2: "Remove",
    live_type: channel.live_type,
  }));

  return {
    data: formattedData,
    totalCount: response?.data?.total || 0,
  };
};

export const getColumns = (handleDelete, deletingId, handleEdit) => [
  {
    key: "name",
    label: "Name",
    render: (item) => (
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
          display: "block",
          minWidth: 0,
        }}
      >
        {trimStr(item.name, 15)}
      </div>
    ),
  },
  {
    key: "media",
    label: "Media",
    render: (item) => (
      <div>
        <MediaImage src={item.media} alt={item.name} />  {/* ← only this changed */}
      </div>
    ),
  },
  {
    key: "rating",
    label: "Rating",
    render: (item) => <div>{item.rating}</div>,
  },
  {
    key: "access",
    label: "Access",
    render: (item) => <div>{item.access}</div>,
  },
  {
    key: "live_type",
    label: "Type",
    render: (item) => <div>{item.live_type}</div>,
  },
  //   {
  //     key: "Streaming_Link",
  //     label: (
  //       <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
  //         Streaming Link
  //       </div>
  //     ),
  //     render: (item) => (
  //       <a style={{ width: "21vw", textAlign: "center" }}>
  //         {getFirst4SegmentsFromUrl(item.Streaming_Link)}
  //       </a>
  //     ),
  //   },
  {
    key: "buttonText",
    render: (item) => (
      <Button onClick={() => handleEdit(item.id, item.metadata_id, item)}>
        {item.buttonText}
      </Button>
    ),
  },
  {
    key: "buttonText2",
    render: (item) => (
      <Button
        onClick={() => handleDelete(item.id, item.metadata_id)}
        loading={deletingId === (item.metadata_id || item.id)}
        disabled={deletingId === (item.metadata_id || item.id)}
      >
        {item.buttonText2}
      </Button>
    ),
  },
];